import React from 'react';

import Translator from 'ggApp/modules/translator/components/PureTranslator';

import { Container, Price, PricePeriod, Profits, Profit, PriceBlock, Text } from './styles';

interface PromoProps {
    className?: string;
    currency: string;
}

export const Promo = ({ className, currency }: PromoProps): JSX.Element => {
    return (
        <Container className={className}>
            <PriceBlock>
                <Price>{currency}99</Price>
                <PricePeriod>
                    <Translator tk="PRODUCT_CARD_PLAN_PERIOD_LABEL_SHORT" />
                </PricePeriod>
            </PriceBlock>
            <Profits>
                <Profit>
                    <Text>
                        <Translator tk="MIXABLE_CARD_PROFIT_1" />
                    </Text>
                </Profit>
                <Profit>
                    <Text>
                        <Translator tk="MIXABLE_CARD_PROFIT_2" />
                    </Text>
                </Profit>
                <Profit>
                    <Text>
                        <Translator tk="MIXABLE_CARD_PROFIT_3" />
                    </Text>
                </Profit>
                <Profit>
                    <Text>
                        <Translator tk="MIXABLE_CARD_PROFIT_4" />
                    </Text>
                </Profit>
            </Profits>
        </Container>
    );
};
